import "babel-polyfill";
import Vue from "vue";
import router from "@/routes/index";
import store from "@/store/index";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";

Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
}).$mount("#app");
